import { Box } from "@mui/material";
import { languageApiData } from "../../../constant/appConstant";
import fetcher from "../../../dataProvider";
import {
  setJourneyText,
  setLoading,
  setSelectedCountry,
  setStepData,
  setStepperConfig,
} from "../../../redux/slices/customerJourney";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { StepperData } from "../../../types/common";
import AppliedSuccessfull from "./AppliedSuccessfull";
import CandidateDetails from "./CandidateDetails";
import Confimation from "./Confimation";
import ExamDetails from "./ExamDetails";
import Location from "./Location";
import PaymentRedirect from "./PaymentRedirect";
import TermsAndCondition from "./TermsAndCondition";
import styles from "./styles";
import { getLanguageCode } from "../../../utils/common";
import { setOneTrustLanguage } from "../../../utils/setOneTrustLanguage";

type StepProps = {
  stepDataManager: Function;
};

const StepManager = (props: StepProps) => {
  const { stepDataManager } = props;
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { stepData, stepperConfig, pageText }: any = customerJourney;
  const dispatch = useAppDispatch();

  const getLanguageData = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      let body = {
        ...languageApiData,
        languageCode: "en-GB",
      };

      const { data } = await fetcher.post("/api/Home", body);
      sessionStorage.setItem(
        "defaultLanguage",
        JSON.stringify(data?.languages)
      );
      setOneTrustLanguage("en-GB");
      dispatch(setJourneyText({ data: data }));
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("error", e);
      dispatch(setLoading({ loading: false }));
    }
  };

  const stepMapper: any = {
    location: (
      <Location
        toggleSteps={(path: string, number: number) =>
          toggleSteps(path, number)
        }
        stepDataManager={stepDataManager}
      />
    ),
    examDetails: (
      <ExamDetails
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number, direction)
        }
        stepDataManager={stepDataManager}
      />
    ),
    paymentRedirect: (
      <PaymentRedirect
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number, direction)
        }
        stepDataManager={stepDataManager}
      />
    ),
    appliedSuccessful: (
      <AppliedSuccessfull
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number, direction)
        }
        stepDataManager={stepDataManager}
      />
    ),
    termsAndConditions: (
      <TermsAndCondition
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number, direction)
        }
        stepDataManager={stepDataManager}
      />
    ),
    candidateData: (
      <CandidateDetails
        //[GP] switch "key" value after language change to clear all component state
        // it should be done in different way, but as long as CandidateDetails is not refactored to not duplicate form state in many place this is the only sensible way
        key={getLanguageCode()}
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number, direction)
        }
        stepDataManager={stepDataManager}
      />
    ),
    confirmation: (
      <Confimation
        toggleSteps={(path: string, number: number, direction?: string) =>
          toggleSteps(path, number)
        }
        stepDataManager={stepDataManager}
      />
    ),
  };

  const toggleSteps = (
    stepValue: string,
    stepNumber: number,
    direction = "front"
  ) => {
    if (stepValue === "location") {
      sessionStorage.clear();
      dispatch(
        setJourneyText({ data: { siteMetadata: pageText, languages: "" } })
      );
      dispatch(setSelectedCountry({ country: undefined }));
      getLanguageData();
    }
    let temp: string = JSON.stringify(stepperConfig);
    let data = JSON.parse(temp);
    data = data.map((item: StepperData, index: number) => {
      if (index < stepNumber) {
        item.completed = true;
        return item;
      } else if (stepNumber === index) {
        item.selected = true;
        item.completed = false;
        dispatch(setStepData({ data: item }));
        sessionStorage.setItem("currentStep", JSON.stringify(item));
        return item;
      } else {
        item.selected = false;
        item.completed = false;
        return item;
      }
    });
    dispatch(setStepperConfig({ data: [...data] }));
  };

  return <Box sx={styles.wrapper}>{stepMapper[stepData?.value]}</Box>;
};

export default StepManager;
